import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-3";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(TawkMessengerVue, {
    propertyId: "663ea7ed07f59932ab3e58ae",
    widgetId: "1htibvtq0",
  });
});
